import React, { useContext, useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { vritix_logo } from "../../../assets/images/tms-image-list";
import { BaseContext } from "../../../contexts/BaseContext";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import { tmsSiderMap } from "../../../constants/tms-sider.map";
import "../../../assets/css/tms-layout/tms-layout.scss";
import checkPermissions from "../../../utils/tms-permissions/tms-permissions";

const TmsHomeSider = ({
  siderCollapsed,
  router,
  toggleSider,
  templeDetails,
}) => {
  const [selectedNavItem, setSelectedNavItem] = useState(["/home"]);
  const [routeMapState, setRouteMapState] = useState();
  const [collapsedWidth, setCollapsedWidth] = useState(80);
  const { userDetails } = useContext(BaseContext);

  const { Sider } = Layout;
  const screens = useBreakpoint();
  useEffect(() => {
    // console.log(userDetails);
    if (screens?.xl || screens?.xxl || screens?.lg) {
      setCollapsedWidth(80);
    } else {
      setCollapsedWidth(0);
    }
  }, [screens]);

  const onMenuClick = (event) => {
    const { key } = event;
    if (collapsedWidth === 0) {
      toggleSider();
    }
    router?.navigate(key);
  };

  useEffect(() => {
    setRouteMapState(
      tmsSiderMap.map((item) => {
        return item.inLayout && checkPermissions(userDetails, item)
          ? {
              label: item.name,
              key: item.route,
              icon: <item.icon />,
            }
          : null;
      })
    );

    setSelectedNavItem(
      tmsSiderMap.find((_item) =>
        router?.location?.pathname?.startsWith(_item.route)
      )?.route
    );
  }, [router?.location?.pathname, userDetails]);

  return (
    <Sider
      className="vf-menu_sider"
      style={{
        background: templeDetails?.colorCode
          ? `#${templeDetails?.colorCode}`
          : "var(--secondary-color)",
        padding: "0 10px",
      }}
    >
      <div className="vf-sider-logo" style={{ background: "transparent" }}>
        <img
          className="vf-sider-inner-logo"
          src={templeDetails?.logoUrl ? templeDetails?.logoUrl : vritix_logo}
          alt="tms_logo"
        />
      </div>
      <Menu
        // theme="light"
        style={{ background: "transparent", border: "none", color: "white" }}
        mode="inline"
        selectedKeys={selectedNavItem}
        onClick={onMenuClick}
        items={routeMapState}
      ></Menu>
    </Sider>
  );
};

export default withRouter(TmsHomeSider);
